import React from 'react'
import Layout from '../../../Layout'
import EditSupplierContainer from '../../../../../Components/UserPart/EditUser/Supplier/EditSupplierContainer'

const EditSupplier = () => {
  return (
    <Layout><EditSupplierContainer/></Layout>
  )
}

export default EditSupplier